import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./styles.css";
import { BrowserRouter } from "react-router-dom"; // 🔥 ADD THIS

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <BrowserRouter> {/* 🔥 WRAP APP */}
    <App />
  </BrowserRouter>
);
